<template>
  <div class="video-container">
    <div class="video" :class="activated ?'activated':''">
      <div class="video-box" v-if="video.number">
        <iframe
          v-if="video.camera_type==1"
          :src="'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/'+this.video.number+'/'+this.video.channel+'.live&autoplay=1&accessToken='+ this.video.accessToken"
          width="100%"
          height="100%"
          :id="'ysOpenDevice'+video.number"
          allowfullscreen
        >
        </iframe>
        <iframe
          v-else
          :src="'../../../static/video/webLive.html?url='+this.video.number+'|kitToken='+ this.video.accessToken"
          width="100%"
          height="100%"
          :id="'ysOpenDevice'+video.number"
          allowfullscreen
        >
        </iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    video: {
      type: Object,
      default: function (e) {
        return {
          index: 0,
          number: 0,
          channel: 1,
          camera_type: 1,
          accessToken: '',
          name: '',
          rnd: 0
        }
      }
    },
    activated: {
      type: Boolean,
      default: function (e) {
        return false
      }
    },
    rnd: {
      type: Number,
      default: function (e) {
        return 0
      }
    },
  },
  data () {
    return {
      url: ''
    }
  },
  methods: {
  } 
}
</script>
<style scoped>
.video-container {
    position: relative;
    max-width: 100%;
    float: left;
    overflow: hidden;
    background: #4C4B4B;
}

.video-container .video {
    border: 2px solid #353535;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}
.video-container .video .video-box{
  width: 100%;
  height: 100%;
  position: relative;
}

.video-container .video iframe{
    width: 100%;
    height: 100%;
    pointer-events: none;
    border:0;
    padding:0;
    margin:0;
}
.video-container .video.activated {
  border-color: #409eff;
}

</style>
